<!-- <forge-menu ng-hide="ctrl.viewOnly" (forge-menu-select)="ctrl.addField($event)" [options]="ctrl.udfsForDisplay">
<forge-icon-button>
  <button type="button">
    <forge-icon name="playlist_add"></forge-icon>
  </button>
  <forge-tooltip>Add field</forge-tooltip>
</forge-icon-button>
</forge-menu> -->

<button mat-fab color="primary" [matMenuTriggerFor]="menu" matTooltip="Add Field" telemetry="Edit-AddField-UserDefinedFields">
  <mat-icon>add</mat-icon>
</button>

<mat-menu #menu="matMenu" overlapTrigger xPosition="after" yPosition="below">
  @for (field of userDefinedFields; track field) {
    <button mat-menu-item (click)="onClick(field)">
      <mat-icon>add</mat-icon>
      <span>{{field.Caption}}</span>
    </button>
  }
</mat-menu>